import { useState } from "react"
import { DataGrid, GridColDef, GridRowClassNameParams } from "@mui/x-data-grid"
import { Block, Add, } from "@mui/icons-material"
import { Box, Button } from "@mui/material"
import { Wrapper, HeaderWrapper, Header, Subheader, DataGridWrapper, } from "./Usermanagement.styles"
import { OperatingCompanyRead, TeamsDetailRead, UserDetailRead } from "../../api/generated"
import OpCoEditForm from "../OpCoEditForm/OpCoEditForm"
import UserCreateForm from "../UserCreateForm/UserCreateForm"
import UserTeamMapping from "../UserTeamMapping/UserTeamMapping"
import { UserRole } from "../../api/generated"
// @ts-ignore
import MappingIcon from "../../assets/Mapping.svg?react"
// @ts-ignore
import EditIcon from "../../assets/Edit.svg?react"

import {
    useCreateTeam,
    useDeleteTeam,
    useGetTeams,
    useGetUserTeams,
    useUpdateTeam,
} from "../../hooks/Teams"
import UserBulkUpload from "../UserBulkUpload/UserBulkUpload"



export interface Iprops {
    users: {
        data: UserDetailRead[] | undefined;
        isLoading: boolean;
        isError: boolean;
        error: Error | null;
    }
    teams: Array<TeamsDetailRead>
    userRole: UserRole | string
}

export default function UserManagementTable({
    users, teams, userRole
}: Iprops) {
    const { data, isLoading, isError, error } = users
    const rows = data
    const [formMode, setFormMode] = useState<'display' | 'create' | 'edit' | 'teamsMap' | 'bulkupload'>('display');
    const [selectedMember, setSelectedMember] = useState<UserDetailRead | null>(null);
    const DataForteamsDropDown = teams;

    const roleMap = {
    "system_admin": "System Administrator",
    "client_admin": "Project Administrator",
    "team_lead": "Team Lead",
    "user": "Reviewer",
    };

    const handleEditButton = (member: UserDetailRead) => {
        setFormMode("edit");
        setSelectedMember(member);
    };
    const handleCreateuserForm = () => {
        setFormMode('create');
        setSelectedMember(null);
    };
    const handleUserBulkUpldForm = () => {
        setFormMode('bulkupload');
    }
    const handleCancelButton = () => {
        setFormMode("display");
        setSelectedMember(null);
    };

    const columns: Array<GridColDef> = [
        {
            field: "user_name",
            headerName: "UserName ",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "name",
            headerName: "First Name",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "last_name",
            headerName: "Last Name",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1.5,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "role",
            headerName: "Role",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
            valueFormatter: (params) => roleMap[params.value] || params.value,
        },
        {
            field: "status",
            headerName: "Status",
            flex: .5,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "last_login",
            headerName: "Last Login",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
            valueFormatter: (params) => {
                const value = params.value;
                if (!value) return '';
                const date = new Date(value);
                const pad = (n) => n.toString().padStart(2, '0');
                return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
            }
        },
        {
            field: "action",
            headerName: 'Action',
            align: 'center',
            headerAlign: 'left',
            sortable: false,
            disableColumnMenu: true,
            renderCell: ({ row: member }) => (
                <EditIcon style={{ cursor: 'pointer' }} onClick={() => handleEditButton(member)} />
            )
        },
    ]

    const noDataStyles = { height: data.length < 1 ? 600 : '', width: data.length < 1 ? '100%' : '' };

    const formComponents = {
        create: (
            <UserCreateForm
                formMode={formMode}
                existedData={selectedMember}
                onCancel={handleCancelButton}
                currentUserRole={userRole}
            />
        ),
        edit: (
            <UserCreateForm
                formMode={formMode}
                existedData={selectedMember}
                onCancel={handleCancelButton}
                currentUserRole={userRole}
            />
        ),
        bulkupload: <UserBulkUpload onCancel={handleCancelButton} />,
        teamsMap: <UserTeamMapping
            formMode={formMode}
            setFormMode={setFormMode}
            onCancel={handleCancelButton}
            DataForteamsDropDown={DataForteamsDropDown}
        />,
    };

    const handleuserteamsTable = () => {
        setFormMode('teamsMap');
    }


    if (isLoading) {
        return <p>Loading opco's...</p>;
    }

    if (isError) {
        return <p>Error loading opco's: {error.message}</p>;
    }
    return (
        <>
            {
                formMode === "display" ? (
                    <Wrapper>
                        <HeaderWrapper >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', mb: 2 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Header sx={{ display: 'inline' }}>User management</Header>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <Button
                                        onClick={handleCreateuserForm}
                                        variant="outlined"
                                        startIcon={<Add />}
                                        sx={{
                                        '& .MuiButton-startIcon': {
                                            mr: .5,
                                        }}}
                                    >
                                        Add new user
                                    </Button>
                                    <Button
                                        onClick={handleUserBulkUpldForm}
                                        variant="outlined"
                                        startIcon={<Add />}
                                        sx={{
                                        '& .MuiButton-startIcon': {
                                            mr: .5
                                        }}}
                                    >
                                        Bulk user upload
                                    </Button>
                                    {
                                        userRole.toLowerCase() !== UserRole.TEAM_LEAD && <Button
                                            onClick={handleuserteamsTable}
                                            variant="outlined"
                                            startIcon={<MappingIcon />}
                                        >
                                            Team mapping
                                        </Button>
                                    }
                                    
                                </Box>
                            </Box>
                        </HeaderWrapper>
                        <DataGridWrapper>
                            <div style={noDataStyles}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    getRowId={(row) => row.email}
                                    hideFooterPagination={true}
                                    getRowClassName={(e: GridRowClassNameParams<any>) => e.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"}
                                    sx={{
                                        border: "none",

                                        '& .MuiDataGrid-cell, & .MuiDataGrid-root, & .MuiDataGrid-columnHeaders': {
                                            borderBottom: 'none',
                                        },
                                        '& .MuiDataGrid-cell': {
                                            padding: '0 12px 0 0',
                                        },
                                        '& .MuiDataGrid-cell:first-of-type': {
                                            padding: '0 12px 0 50px',
                                        },
                                        '& .MuiDataGrid-cell:last-child': {
                                            padding: '0 50px 0 0',
                                        },
                                        '& .MuiDataGrid-columnHeader': {
                                            padding: '0',
                                        },
                                        '& .MuiDataGrid-columnHeader:first-of-type': {
                                            padding: '0 0 0 50px',
                                        },
                                        '& .MuiDataGrid-row.even-row': {
                                            backgroundColor: 'var(--background-off-white)',
                                        },
                                        '& .MuiDataGrid-footerContainer': {
                                            display: 'none',
                                        },
                                        '& .MuiDataGrid-cellContent': {
                                            fontSize: '13px',
                                        },
                                    }}

                                />
                            </div>
                        </DataGridWrapper>
                    </Wrapper>
                ) : formComponents[formMode]

            }
        </>

    )
}
